// import i18n from "i18next";
// import LanguageDetector from "i18next-browser-languagedetector";
// import { initReactI18next } from "react-i18next";

// const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;



// // -----------------------------
// // Initialization guard
// // -----------------------------
// let isInitialized = false;

// // -----------------------------
// // In-memory translation cache
// // -----------------------------
// const translationCache: Record<string, Record<string, string>> = {};

// // ---------------------------------
// const normalizeLang = (lng?: string): string => {
//   if (!lng) return "en-US";

//   const cleaned = lng.replace("_", "-").trim();
//   const parts = cleaned.split("-");

//   const language = parts[0].toLowerCase();
//   const region = parts[1]?.toUpperCase();

//   if (region) {
//     return `${language}-${region}`;
//   }

//   // Default region fallback
//   return `${language}-US`;
// };


// // -----------------------------
// // Load translations from DB (API)
// // -----------------------------
// const loadTranslations = async (
//   lng: string
// ): Promise<Record<string, string>> => {
//    const normalizedLng = normalizeLang(lng);
//   if (translationCache[normalizedLng]) {
//     console.log(`[i18n] Using cached translations for ${normalizedLng}`);
//     return translationCache[normalizedLng];
//   }

//   try { 
//     const response = await fetch(
//       `${API_BASE_URL}languages/translations?langCode=${encodeURIComponent(normalizedLng)}`,
//       {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     if (!response.ok) {
//       throw new Error(`Failed to load translations for ${normalizedLng}`);
//     }

//     const data = await response.json();

//     if (!data || typeof data !== "object") {
//       throw new Error("Invalid translation response format");
//     }

//     translationCache[normalizedLng] = data;
//     return data;
//   } catch (error) {
//     console.error(`[i18n] Error loading translations for ${normalizedLng}:`, error);
//     return translationCache[normalizedLng] || {};
//   }
// };

// // -----------------------------
// // Check if language exists (DB)
// // -----------------------------
// const translationLanguageExists = async (lng: string): Promise<boolean> => {
//   try {
//     const translations = await loadTranslations(lng);
//     return Object.keys(translations).length > 0;
//   } catch {
//     return false;
//   }
// };



// // -----------------------------
// // i18next initialization
// // -----------------------------
// i18n
//   .use(initReactI18next)
//   // .use(LanguageDetector)
//   .init({
//     fallbackLng: "en-US",
//     defaultNS: "translation",   //  IMPORTANT
//     ns: ["translation"],        //  IMPORTANT
//     debug: false,
//     interpolation: {
//       escapeValue: false,
//     },
//     react: {
//       useSuspense: false,
//     },
//     resources: {}, // Loaded manually
//     detection: {
//       order: ["querystring", "localStorage", "navigator"],
//       lookupQuerystring: "lng",
//       lookupLocalStorage: "i18nextLng",
//       caches: ["localStorage"],
//     },
//   });

// // -----------------------------
// // Change language
// // -----------------------------
// export const changeLanguage = async (lng: string): Promise<void> => {
//   console.log("Current i18n language =", i18n.language);
//    const normalizedLng = normalizeLang(lng);

//   try {
//     if (!i18n.hasResourceBundle(normalizedLng, "translation")) {
//       const translations = await loadTranslations(normalizedLng);
//       i18n.addResourceBundle(normalizedLng, "translation", translations, true, true);
//       console.log(" i18n Bundle ========== ", i18n.getResourceBundle(normalizedLng, "translation"));
      
//     }

//     await i18n.changeLanguage(normalizedLng);
//     localStorage.setItem("i18nextLng", normalizedLng);
//     console.log("[i18n] Active language:", i18n.language);

//   } catch (error) {
//     console.error(`[i18n] Failed to change language to ${lng}`, error);

//     if (lng !== "en-US") {
//       await changeLanguage("en-US");
//     }
//   }
// };


// // -----------------------------
// // Initialize i18n
// // -----------------------------
// export const initI18n = async (): Promise<void> => {
//   if (isInitialized) return;

//   const storedLang = localStorage.getItem("i18nextLng");
//   const browserLang = navigator.language || "en-US";

//   // let languageToUse = storedLang || browserLang;
//   let languageToUse = normalizeLang(storedLang || browserLang);


//   const isSupported = await translationLanguageExists(languageToUse);

//   if (!isSupported) {
//     console.warn(
//       `[i18n] No translations for ${languageToUse}, falling back to en-US`
//     );
//     languageToUse = "en-US";
//   }

//   await changeLanguage(languageToUse);
//   isInitialized = true;
// };

// export const i18nReady = (async () => {
//   if (typeof window !== "undefined") {
//     await initI18n();
//   }
// })();
// // -----------------------------
// // Auto initialize (browser only)
// // -----------------------------
// // if (typeof window !== "undefined") {
// //   initI18n().catch((error) => {
// //     console.error("[i18n] Initialization failed", error);
// //   });
// // }

// export default i18n;






import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// const TRANSLATION_BASE_URL = import.meta.env.VITE_TRANSLATION_BASE_URL;
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// Track initialization to prevent duplicate loading
let isInitialized = false;

// Cache for loaded translations to avoid redundant fetches
const translationCache: Record<string, any> = {};

// Define a function to load translations with error handling
const loadTranslations = async (lng: string) => {
  // Return cached translations if available
  if (translationCache[lng]) {
    console.log(`Using cached translations for ${lng}`);
    return translationCache[lng];
  }

  const path1 = `${API_BASE_URL}languages/translations?langCode=${encodeURIComponent(lng)}`;
  // const path2 = `${API_BASE_URL}languages/translations?langCode=${encodeURIComponent(lng)}`;

  try {
    // Fetch both JSON files
    const [data1] = await Promise.all([
      fetch(path1, { cache: "force-cache" }).then((res) => {
        if (!res.ok)
          throw new Error(`Failed to load translations from ${path1}`);
        return res.json();
      }),
      // fetch(path2, { cache: "force-cache" }).then((res) => {
      //   if (!res.ok)
      //     throw new Error(`Failed to load translations from ${path2}`);
      //   return res.json();
      // }),
    ]);

    // Merge both translation objects
    const mergedTranslations = { ...data1 };
    console.log("Data 1  ================ ", data1);
    // console.log("Data 2  ================ ", data2);
    

    // Cache the translations
    translationCache[lng] = mergedTranslations;

    return mergedTranslations;
  } catch (error) {
    console.error(`Error loading translations for ${lng}:`, error);
    return translationCache[lng] || {};
  }
};

// Function to check if a translation file exists
// This is used to determine if we should load a specific language
// and to fall back to a default language if the requested one is not available
// This function uses a HEAD request to check for the existence of the translation file
// It returns true if the file exists, false otherwise
// const translationFileExists = async (lng: string): Promise<boolean> => {
//   const labelUrl = `${API_BASE_URL}languages/translations?langCode=${encodeURIComponent(lng)}`;
//   const tagUrl = `${API_BASE_URL}languages/translations?langCode=${encodeURIComponent(lng)}`;

//  console.log(`Checking translation file for ${lng}: ${labelUrl} and ${tagUrl}`); 
 
//   try {
//     const [labelRes, tagRes] = await Promise.all([
//       fetch(labelUrl, { method: "HEAD" }),
//       fetch(tagUrl, { method: "HEAD" }),
//     ]);
//     // console.log(`Translation file for ${lng} exists:`, res.ok);
    
//     return labelRes.ok && tagRes.ok;
//   } catch (error) {
//     console.error(`Error checking translation file for ${lng}:`, error);
//     return false;
//   }
// };
 

// Initialize i18next
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: "en-US",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    // Disable built-in backend to prevent automatic loading of translation.json
    // We'll handle loading translations manually
    resources: {}, // Start with empty resources
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lng",
      lookupLocalStorage: "lng",
      caches: ["localStorage"],
    },
    debug: false, // Set to true only for debugging
  });

// Define a function to change the language
export const changeLanguage = async (lng: string): Promise<void> => {
  try {
    // Only load translations if they're not already loaded
    if (!i18n.hasResourceBundle(lng, "translation")) {
      const translations = await loadTranslations(lng);
      i18n.addResourceBundle(lng, "translation", translations, true, true);
            console.log(" i18n Bundle ========== ", i18n.getResourceBundle(lng, "translation"));
    }

    // Set the new language
    await i18n.changeLanguage(lng);

    // Update localStorage
    localStorage.setItem("i18nextLng", lng);
  } catch (error) {
    console.error(`Failed to change language to ${lng}:`, error);
    if (lng !== "en-US" && !i18n.hasResourceBundle("en-US", "translation")) {
      console.warn(`Falling back to default language (en-US)`);
      await changeLanguage("en-US");
    }
  }
};

// Initialize with the default language
// export const initI18n = async (): Promise<void> => {
//   // Prevent multiple initializations
//   if (isInitialized) return;
//   const language =localStorage.getItem("i18nextLng") || navigator.language || "en-US";   
//   await changeLanguage(language);
//   isInitialized = true;
// };

// Initialize i18n with the default language. This function checks for the stored language in localStorage or uses the browser's default language
export const initI18n = async (): Promise<void> => {
  if (isInitialized) return;
  // Check for stored language in localStorage or use browser's default language
  const storedLang = localStorage.getItem("i18nextLng");
  const browserLang = navigator.language || "en-US";
  let languageToUse = storedLang || browserLang;
 // Normalize the language code to a standard format (e.g., en-US)
  // const isSupported = await translationFileExists(languageToUse);
  // // console.log(`Using language: ${languageToUse}, Supported: ${isSupported}`);
  // // If the translation file does not exist for the selected language, fall back to en-US
  // // This ensures that we always have a valid language to use
  // if (!isSupported) {
  //   console.warn(`Translation file not found for ${languageToUse}, falling back to en-US`);
  //   languageToUse = "en-US";
  // }
  // Change the language using the changeLanguage function
  await changeLanguage(languageToUse);
  isInitialized = true;
};

export const i18nReady: Promise<void> =
  typeof window !== "undefined"
    ? initI18n().catch((error) => {
        console.error("Failed to initialize i18n:", error);
      })
    : Promise.resolve();

export default i18n;






// import i18n from "i18next";
// import LanguageDetector from "i18next-browser-languagedetector";
// import { initReactI18next } from "react-i18next";

// const TRANSLATION_BASE_URL = import.meta.env.VITE_TRANSLATION_BASE_URL;

// // Track initialization to prevent duplicate loading
// let isInitialized = false;

// // Cache for loaded translations to avoid redundant fetches
// const translationCache: Record<string, any> = {};

// // Define a function to load translations with error handling
// const loadTranslations = async (lng: string) => {
//   // Return cached translations if available
//   if (translationCache[lng]) {
//     console.log(`Using cached translations for ${lng}`);
//     return translationCache[lng];
//   }

//   const path1 = `${TRANSLATION_BASE_URL}labels/locale-${lng}.json`;
//   const path2 = `${TRANSLATION_BASE_URL}tags/locale-lt-${lng}.json`;

//   try {
//     // Fetch both JSON files
//     const [data1, data2] = await Promise.all([
//       fetch(path1, { cache: "force-cache" }).then((res) => {
//         if (!res.ok)
//           throw new Error(`Failed to load translations from ${path1}`);
//         return res.json();
//       }),
//       fetch(path2, { cache: "force-cache" }).then((res) => {
//         if (!res.ok)
//           throw new Error(`Failed to load translations from ${path2}`);
//         return res.json();
//       }),
//     ]);

//     // Merge both translation objects
//     const mergedTranslations = { ...data1, ...data2 };
//     console.log("Data 1  ================ ", data1);
//     console.log("Data 2  ================ ", data2);
    

//     // Cache the translations
//     translationCache[lng] = mergedTranslations;

//     return mergedTranslations;
//   } catch (error) {
//     console.error(`Error loading translations for ${lng}:`, error);
//     return translationCache[lng] || {};
//   }
// };

// // Function to check if a translation file exists
// // This is used to determine if we should load a specific language
// // and to fall back to a default language if the requested one is not available
// // This function uses a HEAD request to check for the existence of the translation file
// // It returns true if the file exists, false otherwise
// const translationFileExists = async (lng: string): Promise<boolean> => {
//   const labelUrl = `${TRANSLATION_BASE_URL}labels/locale-${lng}.json`;
//   const tagUrl = `${TRANSLATION_BASE_URL}tags/locale-lt-${lng}.json`;

//  console.log(`Checking translation file for ${lng}: ${labelUrl} and ${tagUrl}`); 
 
//   try {
//     const [labelRes, tagRes] = await Promise.all([
//       fetch(labelUrl, { method: "HEAD" }),
//       fetch(tagUrl, { method: "HEAD" }),
//     ]);
//     // console.log(`Translation file for ${lng} exists:`, res.ok);
    
//     return labelRes.ok && tagRes.ok;
//   } catch (error) {
//     console.error(`Error checking translation file for ${lng}:`, error);
//     return false;
//   }
// };
 

// // Initialize i18next
// i18n
//   .use(initReactI18next)
//   .use(LanguageDetector)
//   .init({
//     fallbackLng: "en-US",
//     interpolation: {
//       escapeValue: false,
//     },
//     react: {
//       useSuspense: false,
//     },
//     // Disable built-in backend to prevent automatic loading of translation.json
//     // We'll handle loading translations manually
//     resources: {}, // Start with empty resources
//     detection: {
//       order: ["querystring", "localStorage", "navigator"],
//       lookupQuerystring: "lng",
//       lookupLocalStorage: "lng",
//       caches: ["localStorage"],
//     },
//     debug: false, // Set to true only for debugging
//   });

// // Define a function to change the language
// export const changeLanguage = async (lng: string): Promise<void> => {
//   try {
//     // Only load translations if they're not already loaded
//     if (!i18n.hasResourceBundle(lng, "translation")) {
//       const translations = await loadTranslations(lng);
//       i18n.addResourceBundle(lng, "translation", translations, true, true);
//             console.log(" i18n Bundle ========== ", i18n.getResourceBundle(lng, "translation"));
//     }

//     // Set the new language
//     await i18n.changeLanguage(lng);

//     // Update localStorage
//     localStorage.setItem("i18nextLng", lng);
//   } catch (error) {
//     console.error(`Failed to change language to ${lng}:`, error);
//     if (lng !== "en-US" && !i18n.hasResourceBundle("en-US", "translation")) {
//       console.warn(`Falling back to default language (en-US)`);
//       await changeLanguage("en-US");
//     }
//   }
// };

// // Initialize with the default language
// // export const initI18n = async (): Promise<void> => {
// //   // Prevent multiple initializations
// //   if (isInitialized) return;
// //   const language =localStorage.getItem("i18nextLng") || navigator.language || "en-US";   
// //   await changeLanguage(language);
// //   isInitialized = true;
// // };

// // Initialize i18n with the default language. This function checks for the stored language in localStorage or uses the browser's default language
// export const initI18n = async (): Promise<void> => {
//   if (isInitialized) return;
//   // Check for stored language in localStorage or use browser's default language
//   const storedLang = localStorage.getItem("i18nextLng");
//   const browserLang = navigator.language || "en-US";
//   let languageToUse = storedLang || browserLang;
//  // Normalize the language code to a standard format (e.g., en-US)
//   const isSupported = await translationFileExists(languageToUse);
//   // console.log(`Using language: ${languageToUse}, Supported: ${isSupported}`);
//   // If the translation file does not exist for the selected language, fall back to en-US
//   // This ensures that we always have a valid language to use
//   if (!isSupported) {
//     console.warn(`Translation file not found for ${languageToUse}, falling back to en-US`);
//     languageToUse = "en-US";
//   }
//   // Change the language using the changeLanguage function
//   await changeLanguage(languageToUse);
//   isInitialized = true;
// };

// // Only auto-initialize in browser environment to avoid SSR issues
// if (typeof window !== "undefined") {
//   // Use a flag to track if initialization has started
//   let initStarted = false;

//   if (!initStarted) {
//     initStarted = true;
//     initI18n().catch((error) => {
//       console.error("Failed to initialize i18n:", error);
//     });
//   }
// }

// export default i18n;


